import sortBy from 'lodash/sortBy'
import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { AppButton } from 'shared/components/'
import './style.css'

export default class AppButtonGroup extends Component {
  static propTypes = {
    elements: PropTypes.arrayOf(
      PropTypes.shape({
        object: PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          icon: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired
        }),
        object_type: PropTypes.string.isRequired,
        order: PropTypes.number.isRequired
      })
    ),
    params: PropTypes.any,
    themeColor: PropTypes.string.isRequired
  }

  render () {
    return (
      <div className='row centered-content-container'>
        {sortBy(this.props.elements, 'order').map(element =>
          <div key={get(element.object, 'id')} className='col-md-6'>
            <AppButton
              id={get(element.object, 'id')}
              name={get(element.object, 'name')}
              icon={get(element.object, 'icon')}
              description={get(element.object, 'description')}
              params={this.props.params}
              objectId={get(element.object, 'id')}
              objectName={get(element.object, 'name')}
              objectType={element.object_type}
              themeColor={this.props.themeColor}
            />
          </div>
        )}
      </div>
    )
  }
}
